<template>
  <RevCheckbox
    v-if="offer.compliancy.isUserAgreementRequired"
    :id
    :disabled
    :model-value="offer.compliancy.isUserAgreementAccepted"
    @update:model-value="handleCheck"
  >
    <template #label>
      <div class="leading-[1]">
        <Terms
          :documents="offer.compliancy.documents"
          :offer-type="offer.type"
          :payment-frequency="offer.paymentFrequency"
        />
      </div>
    </template>
  </RevCheckbox>

  <Terms
    v-else
    :documents="offer.compliancy.documents"
    :offer-type="offer.type"
    :payment-frequency="offer.paymentFrequency"
  />
</template>

<script setup lang="ts">
import type { InsuranceOffer } from '@backmarket/http-api/src/api-models/InsuranceOffer'
import { RevCheckbox } from '@ds/components/Checkbox'

import Terms from './components/Terms/Terms.vue'

const props = defineProps<{
  id: string
  offer: InsuranceOffer
  disabled: boolean
}>()

const emit = defineEmits<{
  update: [updatedInsurance: InsuranceOffer]
}>()

function handleCheck(isUserAgreementAccepted: boolean | string[]) {
  if (typeof isUserAgreementAccepted !== 'boolean') return

  emit('update', {
    ...props.offer,
    compliancy: { ...props.offer.compliancy, isUserAgreementAccepted },
  })
}
</script>
